import {action, getter, Module, mutation, VuexModule} from "vuex-class-component"
import {Site} from "@/interface"
import API from "@/api"

@Module({namespacedPath: "site/"})
export default class SiteModule extends VuexModule {

  @getter
  public sites: Site[] = []

  @mutation
  setSites(sites: Site[]) {
    this.sites = sites
    this.sites.splice(0, 0)
  }

  @action()
  async fetchSites(force: boolean = false) {
    if (this.sites.length === 0 || force) {
      const sites = await API.getSites()
      this.setSites(sites)
    }
  }

  @action
  async create(site: Site) {
    try {
      await API.createSite(site)
      await this.fetchSites(true)
    } catch (e) {
      alert("エラー")
      console.error(e)
    }
  }

  @action
  async edit(site: Site) {
    try {
      await API.editSite(site)
      await this.fetchSites(true)
    } catch (e) {
      alert("エラー")
      console.error(e)
    }
  }
}